import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const tests: ThemeUICSSObject = {
  /* PREPEND HERE */
};
